import React from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

export default function DateSelector({ 
    fromDate, 
    setFromDate, 
    toDate, 
    setToDate,
    target,
    setTarget }) {
    const selected = "inline-flex items-center transition-colors duration-300 ease-in hover:text-purple-500 focus:text-purple-500 focus:outline-none rounded-l-full px-4 py-2 bg-white rounded-full text-purple-500"
    const notSelected = "inline-flex items-center transition-colors duration-300 ease-in hover:text-purple-500 focus:text-purple-500 focus:outline-none rounded-r-full px-4 py-2"
    return (
        <div className="flex flex-col md:flex-row justify-between mb-5 px-6">
            <div className="flex flex-col">
                <label htmlFor="fromDate" className="block tracking-wide text-gray-600 text-xs font-bold mb-2">
                    Version Start Date
                </label>
                <DatePicker
                    id="fromDate"
                    selected={fromDate}
                    onChange={setFromDate}
                    maxDate={toDate}
                    className="appearance-none border rounded w-full py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                    required={true}
                />
            </div>
            <div className="flex flex-col">
                <label htmlFor="toDate" className="block tracking-wide text-gray-600 text-xs font-bold mb-2">
                    Version End Date
                </label>
                <DatePicker
                    id="toDate"
                    selected={toDate}
                    onChange={setToDate}
                    minDate={fromDate}
                    // maxDate={new Date('06/30/2020')}
                    className="appearance-none border rounded w-full py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                    required={true}
                />
            </div>
            <div className="flex flex-col">
                <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2">
                    Target
                </label>
                <div className="bg-gray-200 text-sm text-gray-500 leading-none border-2 border-gray-200 rounded-full inline-flex">
                    <button className={target === "Party" ? selected: notSelected} onClick={() => setTarget('Party')}>
                        <span>Party</span>
                    </button>
                    <button className={target === "Application" ? selected: notSelected} onClick={() => setTarget('Application')}>
                        <span>Application</span>
                    </button>
                </div>
            </div>
        </div>
    )
}